import { createContext, useContext } from 'react';

// A tab's Flag button asking the chat to take the flag's reason: the chat opens in flag
// mode, and sending the reason flags the tab (through the usual confirmation). The flag's
// reason is posted to the thread once the flag is saved (see DataQA's handleFlagConfirm).
export interface FlagRequest {
  // e.g. 'Flag Media Inputs'.
  label: string;
  // The note so far, e.g. from a cancelled attempt.
  notes: string;
  onSubmit: (notes: string) => void;
}

export interface CommentsContextValue {
  requestFlag: (request: FlagRequest) => void;
}

// Null outside the page (e.g. a section's own Storybook story): Flag then takes its note
// in a popover instead.
export const CommentsContext = createContext<CommentsContextValue | null>(null);

export const useCommentsContext = (): CommentsContextValue | null => useContext(CommentsContext);
